import {EntityModel} from '../../../core/model/entity.model';
import {LocalDate, LocalTime} from '@js-joda/core';

export class Absence extends EntityModel {
  public employee?: number;
  public employeeName?: string;
  public employeeArchived?: boolean;
  public date?: LocalDate;
  public hours?: LocalTime;
  public details?: string;
  public type?: AbsenceType;
  public days?: number;
}

export enum AbsenceType {
  PAID_VACATION= 'PAID_VACATION',
  MEDICAL_DISABILITY= 'MEDICAL_DISABILITY',
  UNPAID_VACATION= 'UNPAID_VACATION',
  PAID_LEAVING = 'PAID_LEAVING',
  UNPAID_LEAVING = 'UNPAID_LEAVING',
  OTHER= 'OTHER'
}
